import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss']
})

export class NotificationDetailsComponent implements OnInit {
  itemList = [
    {
      label: 'app.type',
      value: this.notificationData['selected_row'].type,
      isType: true
    },
    {
      label: 'app.detected-value',
      value: this.notificationData['selected_row'].value.toFixed(2) + ' ' + this.notificationData['selected_row'].metric
    },
    {
      label: 'app.expected-value',
      value: this.notificationData['selected_row'].expected_value.toFixed(2) + ' ' + this.notificationData['selected_row'].metric
    },
    {
      label: 'app.anomaly-date',
      value: new Date(this.notificationData['selected_row'].anomaly_date).toLocaleString('en-GB', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
    }
  ];

  ngOnInit(): void { }
  
  constructor(@Inject(MAT_DIALOG_DATA) public notificationData: any,
    private dialogRef: MatDialogRef<NotificationDetailsComponent>) { }

  getTypeColor(type: string): string {
    switch (type) {
      case 'notification':
        return '#72bbc2';
      case 'warning':
        return '#FFC000';
      default:
        return '#ff5757';
    }
  }

  close() {
    this.dialogRef.close();
  }

}
